// extracted by mini-css-extract-plugin
export default {"list":"menu-profile_list__BbZ9Y","item":"menu-profile_item__SUICA","item_active":"menu-profile_item_active__a45+a","tip":"menu-profile_tip__UmpKd"};